import { render, staticRenderFns } from "./OrderDetailsLocation.vue?vue&type=template&id=43b35297&"
import script from "./OrderDetailsLocation.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports